import { useCallback, useState } from "react";

const readValue = (key, initialValue) => {
  try {
    const raw = window.sessionStorage.getItem(key);
    return raw === null ? initialValue : JSON.parse(raw);
  } catch {
    return initialValue;
  }
};

const writeValue = (key, value) => {
  try {
    window.sessionStorage.setItem(key, JSON.stringify(value));
  } catch {
    // sessionStorage unavailable (private mode, quota, etc.) — state just won't persist
  }
};

// Drop-in replacement for useState whose value survives an unmount/remount
// (e.g. navigating away from a list page and back) by mirroring it to
// sessionStorage under `key`. `key` must be unique per field/table instance.
export const usePersistedState = (key, initialValue) => {
  const [value, setValue] = useState(() => readValue(key, initialValue));

  const setPersistedValue = useCallback(
    (update) => {
      setValue((current) => {
        const next = typeof update === "function" ? update(current) : update;
        writeValue(key, next);
        return next;
      });
    },
    [key],
  );

  return [value, setPersistedValue];
};
